
const ACTIONS = {
  SET_ACCESS_TOKEN: 'SET_ACCESS_TOKEN',
  TOGGLE_LOGGING_IN: 'TOGGLE_LOGGING_IN',
};

const STORAGE_KEY = 'payment_run_access_token';


export default {
  namespaced: true,
  state: {
    accessToken: window.localStorage.getItem(STORAGE_KEY),
    loggingIn: false
  },
  actions: {
    setToken: ({ commit }, { accessToken }) => {
      window.localStorage.setItem(STORAGE_KEY, accessToken);
      commit(ACTIONS.SET_ACCESS_TOKEN, { accessToken });
    },
    logout: ({ commit }) => {
      window.localStorage.removeItem(STORAGE_KEY);
      commit(ACTIONS.SET_ACCESS_TOKEN, { accessToken: null });
    }
  },
  mutations: {
    [ACTIONS.SET_ACCESS_TOKEN]: (state, { accessToken }) => {
      Object.assign(state, { accessToken })
    },
    [ACTIONS.TOGGLE_LOGGING_IN]: (state) => {
      Object.assign(state, { loggingIn:  ! state.loggingIn })
    }
  },
  getters: {
    accessToken(state) {
      return state.accessToken;
    },
    isAuthenticated(state) {
      return state.accessToken !== null;
    },
    isLoggingIn(state) {
      return state.loggingIn;
    }
  }
}
